import { SET_GENERAL_DETAILS } from 'redux/actionTypes';
export function setGeneralDetails(data) {
	return {
		type: SET_GENERAL_DETAILS,
		data,
	};
}
